import React from "react";
import "./globalDirectory.css";

/**
 * Composes directory UI in order: filters → optional approvals → grid → pagination.
 * Each slot is optional (omit or pass null).
 */
export default function GlobalDirectoryShell({
  filters = null,
  approvals = null,
  grid = null,
  pagination = null,
  className = ""
}) {
  return (
    <div className={`gds-shell ${className}`.trim()}>
      {filters ? <div className="gds-shell__filters">{filters}</div> : null}
      {approvals ? (
        <div className="gds-shell__approvals">{approvals}</div>
      ) : null}
      {grid ? <div className="gds-shell__grid">{grid}</div> : null}
      {pagination ? (
        <div className="gds-shell__pagination">{pagination}</div>
      ) : null}
    </div>
  );
}
